import { asPercentageOrBlank, asUnitPrice } from '../utils/formatters';

export default [
  {
    displayString: 'Revenue Stream',
    accessor: 'name',
  },
  {
    displayString: '% Yield',
    accessor: 'avgPercent',
    format: asPercentageOrBlank,
  },
  {
    displayString: 'Price',
    accessor: 'avgUnitCost',
    // Pass item as the second parameter to format to use units for the item.
    format: asUnitPrice,
  },
];
